var exports = {
  "AM": "Popover__2nitQm",
  "lg": "aboveCaret__uJVqUw",
  "hl": "PopoverContent__qv5z7u",
  "Pf": "belowCaret__jXFmHK",
};

module.exports = exports;
